import React from 'react'
import classNames from 'classnames'
import { HiChevronLeft }  from "react-icons/hi"

const Prev = props => {

	const { currentPage, pagerClass, onPrev } = props

	const disabled = currentPage <= 1 

	const onPrevClick = e => {
		if(disabled) {
			return 
		}
		onPrev(e)
	}

	const pagerPrevClass = classNames(
		pagerClass.default, 
		'pagination-pager-prev', 
		disabled ? pagerClass.disabled : pagerClass.inactive
	)

	return (
		<span
			className={pagerPrevClass}
			onClick={onPrevClick}
			onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onPrevClick(e); } }}
			role="button"
			tabIndex={disabled ? -1 : 0}
			aria-disabled={disabled}
		>
			<HiChevronLeft />
		</span>
	)
}

export default Prev
